// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;That they may shoot at the blameless from hiding places;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;suddenly they shoot, and are not seen.<br> </p> </div></div>";
// Exports
module.exports = code;